import './styles.scss';

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import { Text, Button } from "@fragments";
import { AddRounded, SettingsRounded } from "@mui/icons-material";
import { SlowMotionVideoRounded } from "@material-ui/icons";

import VideoCard from "../VideoCard";

function ModuleBanner({ banner }) {
    if (!banner) return <></>;
    return (
        <div className="module-banner">
            <img className="module-banner-main" src={banner} alt="" />
            <img className="effect-01" src={banner} alt="" />
        </div>
    );
}

export default function Playlist({
    content,
    course,
    handleOpenContent,
    handleEdit,
    handleAddContent,
    handleEditContent,
}) {
    // Calculate responsive items based on aspect ratios and available space
    const calculateResponsiveItems = () => {
        // largura padrão caso não haja lições
        const defaultWidth = 170;

        // Get lesson widths based on aspect ratios - padronizando larguras conforme solicitado
        const lessonWidths = content.content.length > 0
            ? content.content.map(lesson => lesson.video?.aspect_ratio > 1 ? 300 : 170)
            : [defaultWidth]; // garante pelo menos um item

        // Calculate average width for the carousel
        const averageWidth = lessonWidths.reduce((sum, width) => sum + width, 0) / lessonWidths.length;

        // Gap entre os itens (do CSS: gap: 12px)
        const gap = 12;

        // Larguras aproximadas para cada breakpoint
        const containerWidths = {
            superLargeDesktop: 1600 - 200,
            desktop: 1024 - 200,
            tablet: 768 - 200,
            mobile: 768 - 100,
        };

        const calculateItems = (containerWidth) => {
            const availableWidth = containerWidth - gap;
            const itemsThatFit = Math.floor(availableWidth / (averageWidth + gap));

            // sempre pelo menos 1 item
            return Math.max(1, Math.min(itemsThatFit, lessonWidths.length));
        };

        return {
            superLargeDesktop: {
                breakpoint: { max: 4000, min: 1600 },
                items: calculateItems(containerWidths.superLargeDesktop),
            },
            desktop: {
                breakpoint: { max: 1600, min: 1024 },
                items: calculateItems(containerWidths.desktop),
            },
            tablet: {
                breakpoint: { max: 1024, min: 768 },
                items: calculateItems(containerWidths.tablet),
            },
            mobile: {
                breakpoint: { max: 768, min: 0 },
                items: calculateItems(containerWidths.mobile),
            },
        };
    };

    const responsive = calculateResponsiveItems();

    return (
        <div className="playlist-container">
            <div className="playlist-header">
                <ModuleBanner banner={content.banner} />
                <div className="playlist-header-info">
                    <Text.span
                        left={<SlowMotionVideoRounded color="white" />}
                        value={`PLAYLIST • ${content.content.length} vídeos`}
                        contrast={6}
                    />
                    <Text.h2
                        value={content.name}
                        className="playlist-name"
                    />
                    <Text.h4
                        value={content.description}
                        className="playlist-description"
                        maxLines={2}
                        contrast={6}
                    />
                </div>

                {handleEdit && (
                    <Button
                        className="mb-2"
                        color="overlay"
                        onClick={() => handleEdit(content)}
                        icon={<SettingsRounded />}
                    />
                )}
            </div>
            <Carousel
                responsive={responsive}
                infinite={false}
                draggable={false}
                swipeable={false}
                keyBoardControl={true}
                containerClass="playlist pb-1"
                itemClass="lesson-container"
            >
                {handleAddContent && (
                    <div
                        key={`lesson-add`}
                        className="lesson-add"
                        onClick={() => handleAddContent({ playlist: content.id, course })}
                    >
                        <AddRounded className="play-lesson" />
                    </div>
                )}
                {content.content.map((lesson, i) => (
                    <VideoCard
                        key={`lesson-${i}`}
                        lesson={lesson}
                        onClick={() => handleOpenContent(content, i)}
                        onEdit={handleEditContent}
                    />
                ))}
            </Carousel>
        </div>
    );
}